import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { Grid, makeStyles } from '@material-ui/core';
import CarpentryOrder from '../../Order/CarpentryOrder';
import React, { useState, useEffect } from 'react';
import BackForwardButton from '../../Shared/BackForwardButton';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { xsValue } from '../../../Config/constants'
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { productionOrderStates as state } from '../../../Config/productionOrderStates'
import { connect } from 'react-redux';

export const CarpentryOrderOverviewPage = (props) => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [searchString, setSearchString] = useState("")
    const [productionOrders, setProductionOrders] = useState([])
    const [noOrdersFound, setNoOrdersFound] = useState(false)
    const [reload, setReload] = useState(false)

    useEffect(() => {
        setReload(false);

        if (searchString) {
            dataService.getProductionOrdersByCarpentrySearchText(searchString).then(orders => {
                if (orders.length === 0) {
                    setNoOrdersFound(true)
                }
                else {
                    setNoOrdersFound(false)
                    setProductionOrders(orders)
                }
            }).catch((error) => { toast.error(error, { position: "top-center" }) })
        }
        else {
            setNoOrdersFound(false)
            dataService.getProductionOrdersByCarpentryMachine(props.workstation.selectedCarpentryWorkstationId).then(orders => {
                setProductionOrders(orders)
            }).catch((error) => { toast.error(error, { position: "top-center" }) })
        }

        return () => { }

    }, [searchString, props.workstation.selectedCarpentryWorkstationId, reload]);

    let activeProductionOrders = <React.Fragment></React.Fragment>
    let doneProductionOrders = <React.Fragment></React.Fragment>

    if (productionOrders) {
        activeProductionOrders = productionOrders.filter(x => x.productionOrderStatus !== state.DONE && x.productionOrderStatus !== state.STOPPED).sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={"ActiveGrid_" + order.productionOrderReference} className={classes.gridmargin} xs={xsValue}><CarpentryOrder key={"ActiveCarpentry_" + order.productionOrderReference} actions={props.actions} productionOrder={order} refreshOrders={refreshOrders} setReload={setReload} {...props}></CarpentryOrder></Grid>));
        doneProductionOrders = productionOrders.filter(x => x.productionOrderStatus === state.DONE || x.productionOrderStatus === state.STOPPED).sort((a, b) => new Date(a.startedOnPlanned) - new Date(b.startedOnPlanned)).map((order) => (<Grid item key={"Grid_" + order.productionOrderReference} className={classes.gridmargin} xs={xsValue}><CarpentryOrder key={"Carpentry_" + order.productionOrderReference} actions={props.actions} refreshOrders={refreshOrders} productionOrder={order} {...props}></CarpentryOrder></Grid>));
    }
    if (searchString && !noOrdersFound) {
        activeProductionOrders = productionOrders.sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={"SearchGrid_" + order.productionOrderReference} className={classes.gridmargin} xs={xsValue}><CarpentryOrder key={"SearchCarpentry_" + order.productionOrderReference} actions={props.actions} productionOrder={order} refreshOrders={refreshOrders} setReload={setReload} {...props}></CarpentryOrder></Grid>));
        doneProductionOrders = activeProductionOrders
    }
    if (noOrdersFound) {
        doneProductionOrders = <div className={classes.noOrdersFound}>{t("No orders found for the search criteria entered")}</div>
        activeProductionOrders = doneProductionOrders
    }

    function searchOrder(e) {
        setSearchString(e.target.value)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    function refreshOrders() {
        dataService.getProductionOrdersByCarpentryMachine(props.workstation.selectedCarpentryWorkstationId).then(orders => {
            if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {
                setProductionOrders(orders)
            }

        }).catch((error) => { toast.error(error, { position: "top-center" }) })
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return <div className={classes.backGround}>
        <div className={classes.spacer80}>
            <div className={classes.left}>
                <NavLink className={classes.navButton} to={`/`}>
                    <BackForwardButton direction={'Back'} textOverride={t("Back to workstations")}></BackForwardButton>
                </NavLink>
                <div className={classes.title}>{t('Carpentry queue')}</div>
            </div>
            <div className={classes.right}>
                <div className={classes.searchContainer}>
                    <TextField
                        className={classes.search}
                        id="input-with-icon-textfield"
                        variant="outlined"
                        size="small"
                        onChange={(e) => searchOrder(e)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <img className={classes.eye} src={process.env.PUBLIC_URL + '/img/search.svg'} alt={""}></img>
                                </InputAdornment>
                            ),
                        }}>
                    </TextField>
                    <div className={classes.searchButtons}>
                        <button className={classes.refreshButton} onClick={() => refreshOrders()}>
                            <AutorenewIcon className={classes.refreshIcon}></AutorenewIcon>
                            <div className={classes.refreshText}>{t("REFRESH")}</div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <AppBar position="static" className={classes.appBar}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label={t("ACTIVE")} {...a11yProps(0)} className={clsx({ [classes.activeTab]: value === 0, [classes.notActiveTab]: value !== 0 })} />
                <Tab label={t("DONE")} {...a11yProps(1)} className={clsx({ [classes.activeTab]: value === 1, [classes.notActiveTab]: value !== 1 })} />
            </Tabs>
        </AppBar>
        <TabPanel key={"CarpentryActiveTab"} value={value} index={0}>
            <Grid container spacing={3} className={classes.grid}>
                {activeProductionOrders}
            </Grid>
        </TabPanel>
        <TabPanel key={"CarpentryFinishedTab"} value={value} index={1}>
            <Grid container spacing={3} className={classes.grid}>
                {doneProductionOrders}
            </Grid>
        </TabPanel>
    </div>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'
    },
    backGround: {
        position: "relative",
    },

    gridmargin: {
        minWidth: "450px",
        paddingRight: "0.8% !important",
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column'
    },
    navButton: {
        textDecoration: "none",
        border: "none",
        outline: "none",
        marginLeft: "18px"
    },
    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        paddingLeft: "5px",
        marginLeft: "20px"
    },
    date: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        marginTop: "4px",
        paddingLeft: "7px",
        marginBottom: "3px",
        marginLeft: "20px"
    },
    search: {
        width: "100%",
        backgroundColor: "white",
        marginTop: "5px",
    },
    left: {
        width: "45%",
        height: "70px",
        float: 'left'
    },
    right: {
        width: "55%",
        height: "90px",
        float: 'right',
        textAlign: "right",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"
        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    refreshButton: {
        height: "40px",
        border: "none",
        color: "white",
        outline:  "1px solid " + FlagstoneTheme.palette.primary.main,
        backgroundColor: FlagstoneTheme.palette.primary.main,
        borderRadius: "5px",
        marginTop: "10px",
        cursor: "pointer",
        zIndex: "999",
        paddingRight: "10px",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        display: "flex",  
         '&:hover': {
            backgroundColor: "white",
            color: FlagstoneTheme.palette.primary.main,

        },
    },
    switchButton: {
        cursor: "pointer",
        zIndex: "999",
        color: FlagstoneTheme.palette.primary.main,
    },
    switchMode: {
        height: "40px",
        border: "none",
        outline: "none",
        zIndex: "999",
        position: "relative",
        right: "30px",
        paddingRight: "5px",
    },
    refreshIcon: {
        float: "left",
    },
    refreshText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        float: "left",
        cursor: "pointer"
    },
    switchText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        float: "left",
        paddingTop: "13px",

    },
    noOrdersFound: {
        fontSize: "18px",
        fontFamily: "Lato, sans-serif",
        color: "#8D8D8D",
        padding: "10px",
        marginLeft: "10px"

    },
    scissorStatusContainer: {
        width: "50%",
        maxWidth: "350px",
        overflow: "hidden",
        float: "left",
        paddingTop: "5px",
        marginRight: "15px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: 'column',
    },
    searchContainer: {
        float: "right",
        display: "flex",
        flexDirection: 'column',
        paddingRight: '24px'
    },
    searchButtons: {
        width: "100%",
        display: "flex",
        flexDirection: 'column'
    }
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(CarpentryOrderOverviewPage)